import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { getCurrentUser } from './utils/auth';
import LiveAppUpdater from './utils/liveAppUpdater';

const PrivateRoute = ({ children }) => {
  return getCurrentUser() ? children : <Navigate to="/login" replace />;
};

const LoginRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search || '');
  if (!params.get('wl') && !params.get('admin_id')) {
    const appMatch = location.pathname.match(/^\/apps\/(\d+)(?:\/|$)/);
    if (appMatch) params.set('wl', appMatch[1]);
  }
  const query = params.toString();
  return <Navigate to={`/login${query ? `?${query}` : ''}`} replace />;
};

function App() {
  return (
    <>
      <LiveAppUpdater />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="*" element={<LoginRedirect />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
